import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  User,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.authorization}users/seller/${COMMON_QUERY_PARAMS.SELLER_ID}`;

interface GetUsersInformationBySellerIdQueryPayload {
  sellerId: string;
}

const getUsersInformationBySellerIdQuery = async ({
  sellerId,
}: GetUsersInformationBySellerIdQueryPayload): Promise<
  BackResponse<User[]> | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    const response = await apiCall<BackResponse<User[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getUsersInformationBySellerIdQuery;
